import allImgPaths from "assets/images"
import Tooltip from "components/common/tooltip/Tooltip"

const RfpDrag = ({ dragItem }: any) => {

    const drag = (position: string) => {
        dragItem(position)
    }

    return (
        <div className="py-2 px-2 border-r border-[#e6e6e6] mr-2 flex flex-col justify-center gap-y-5">
            <span className="relative group">
                <img onClick={() => drag('up')} className='self-center cursor-pointer min-w-[22.5px] min-h-[22.5px] max-w-[22.5px] max-h-[22.5px] hover:bg-[#e6e7e8] rounded' src={allImgPaths.downArrowIcon4} alt="down" />
                <Tooltip
                    list={[
                        {
                            name: "Move Up",
                            _id: "1",
                        },
                    ]}
                    styles="bottom-full mb-2 !min-w-[80px]"
                    position="rotate-180 -bottom-2"
                />
            </span>
            <span className="relative group">
                <img onClick={() => drag('down')} className='self-center cursor-pointer min-w-[22px] min-h-[22px] max-w-[22px] max-h-[22px] hover:bg-[#e6e7e8] rounded' src={allImgPaths.downArrowIcon5} alt="up" />
                <Tooltip
                    list={[
                        {
                            name: "Move Down",
                            _id: "2",
                        },
                    ]}
                    styles="top-full !min-w-[96px] mt-1.5 -ml-0.5"
                    position="rotate-0 -top-2"
                />
            </span>
        </div>
    )
}

export default RfpDrag